export default __webpack_public_path__ + "static/media/logo.2401cb86.svg";